import React, { useState } from 'react';
import useTheme from '@mui/material/styles/useTheme';
import { Form } from 'react-final-form';
import { TextField } from '../../lib/mui-rff/TextField';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import useNotification from 'effects/useNotification';
import Typography from '@mui/material/Typography';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { isRequired, isValidEmail, composeValidators } from '../../utilities/regEx';
import { tcnAddEmailToKlaviyo } from 'lib/tcn';
import { serverErrorMessage } from 'utilities/constants';
import LoadingPanel from 'components/Progress/LoadingPanel';
import Box from '@mui/system/Box';

const NewsletterForm: React.FC = () => {
  const showMessage = useNotification();
  const [success, setSuccess] = useState(false);
  const theme = useTheme();

  const onSubmit = async (value: any) => {
    try {
      await tcnAddEmailToKlaviyo({ email: value.email });
      setSuccess(true);
    } catch (error) {
      setSuccess(false);
      console.debug('error', error);
      showMessage(serverErrorMessage, 'error');
    }
  };

  return (
    <>
      {!success && (
        <Form
          onSubmit={onSubmit}
          render={({ handleSubmit, form, pristine, values, valid, submitting }) => (
            <form onSubmit={handleSubmit}>
              <Box style={{ position: 'relative' }}>
                {submitting && <LoadingPanel coverMode />}
                <Stack direction="row" alignItems="center" spacing={2}>
                  <TextField
                    fullWidth
                    margin="none"
                    variant="standard"
                    placeholder="Enter your email"
                    helperText="Get your gift card news before anyone else"
                    name="email"
                    required
                    fieldProps={{
                      validate: composeValidators(isRequired, isValidEmail),
                    }}
                  />
                  <Button
                    sx={{
                      minWidth: {
                        xs: 105,
                        sm: 140,
                      },
                    }}
                    onClick={handleSubmit}
                    type="submit"
                    variant="outlined"
                    size="small"
                    disabled={submitting}
                  >
                    Sign Up
                  </Button>
                </Stack>
              </Box>
            </form>
          )}
        />
      )}
      {success && (
        <Stack>
          <Stack direction="row" justifyContent="space-between" sx={{ borderBottom: ` 1px solid ${theme.palette.text.secondary}`, marginBottom: 0.5, marginTop: 1 }}>
            <Typography variant="body1" gutterBottom>
              Success!
            </Typography>
            <CheckCircleOutlineIcon sx={{ color: theme.palette.success.main, mt: { xs: '-5px', md: '-3px' } }} />
          </Stack>
          <Typography variant="caption" gutterBottom color={theme.palette.text.secondary}>
            Thanks for subscribing
          </Typography>
        </Stack>
      )}
    </>
  );
};

export default NewsletterForm;
